<script lang="ts">
    import cn from 'classnames';

    import { onMount } from 'svelte';

    import { getBorderColorByNftLevel } from './functions';

    import { type Action, setActionFunc } from '@uikit/actions';
    import { SvgIcon, SvgIconTypes } from '@uikit/svg-icon';
    import { type DataAttrs, Target } from '@uikit/types';

    import { Retired } from './components/retired';
    import { ShapeContainer } from './components/shape-container';
    import { Thumb } from './components/thumb';
    import { Badge, BorderColor, Icons, Shape, Size } from './types';

    import s from './avatar.module.css';

    export let action: Action | undefined = undefined;
    export let userName: string;
    export let userId: number;
    export let size: Size = Size.small;
    export let href: NullableString = undefined;
    export let shape: Shape = Shape.rounded;
    export let thumbUrl: NullableString = undefined;
    export let isOnline: boolean = false;
    export let isRetired: boolean = false;
    export let tooltipText: NullableString = undefined;
    export let badge: NullableType<Badge> = undefined;
    export let borderColor: NullableType<BorderColor> = undefined;
    export let classes: string = '';
    export let nftLevel: 1 | 2 | 3 | undefined = undefined;
    export let imgLazyLoad: boolean = false;
    export let isDesktop: boolean = false;
    export let shapeContainerClasses: string = '';
    export let target: Target = Target.self;
    export let attrs: Partial<DataAttrs> = {};

    shape = nftLevel ? Shape.hexagon : shape;

    $: ({ actionFunc, actionParams } = setActionFunc(action));

    onMount(() => {
        if (shape === Shape.hexagon && !borderColor) {
            borderColor = getBorderColorByNftLevel(nftLevel || 1);
        }
    });
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class={cn(s.avatar, s[shape], s[size], { [s.mobile]: !isDesktop }, classes)}
    on:click
    data-tooltip={isRetired ? tooltipText : ''}
    use:actionFunc={actionParams}
    {...attrs}
>
    {#if isRetired}
        <ShapeContainer {shape} {size} isRetired classes={shapeContainerClasses}>
            <Retired {size} />
        </ShapeContainer>
    {:else}
        <ShapeContainer {shape} {size} {borderColor} classes={shapeContainerClasses}>
            <Thumb
                {userName}
                {userId}
                {thumbUrl}
                {size}
                {href}
                {target}
                {imgLazyLoad}
                attrs={{ 'data-testid': 'avatar-img' }}
            />
        </ShapeContainer>

        {#if isOnline && size !== Size.small}
            <div class={s.online}></div>
        {/if}
        {#if badge}
            {@const colorHeart = badge === Badge.heart ? SvgIconTypes.Color.enabled : null}
            {@const colorUser = badge === Badge.userSingle ? SvgIconTypes.Color.extraBlue : null}
            {@const colorCreator = badge === Badge.creator ? SvgIconTypes.Color.extraGreen : null}
            {@const colorProducer = badge === Badge.producer ? SvgIconTypes.Color.extraBlue : null}
            {@const color = colorHeart || colorUser || colorCreator || colorProducer}
            <div class={cn(s.badge, { [s.bg]: badge !== Badge.heart, [s.heart]: badge === Badge.heart })}>
                <SvgIcon icon={Icons[badge]} {color} />
            </div>
        {/if}
    {/if}
</div>
